import React from "react";
import "./NotificationList.scss";
import Notification from "../../ui/Notification/Notification";
import NotificationCloseButton from "../../ui/Notification/NotificationCloseButton";
import { notificationType } from "../../constants";
import { teaserListDetail } from "../../utils/urls";
import { Link } from "react-router-dom";

const NotificationList = ({ notifications, onClose, onAllClose }) => {
  function renderNotification(notification) {
    const handleClose = () => {
      onClose({ id: notification.id });
    };

    if (notification.type == notificationType.simple) {
      return (
        <Notification
          title={notification.title}
          color={notification.color}
          onClose={handleClose}
          key={notification.id}
        >
          {notification.text}
        </Notification>
      );
    }

    if (notification.type == notificationType.cardDone) {
      return (
        <Notification
          title="Задача выполнена"
          color="green"
          onClose={handleClose}
          key={notification.id}
        >
          Долг по <a>{notification.object_name}</a> закрыт, карточка более не
          активна.
        </Notification>
      );
    }

    if (notification.type == notificationType.cardFail) {
      return (
        <Notification
          title="Задача не выполнена"
          color="red"
          onClose={handleClose}
          key={notification.id}
        >
          Вы более не курируете <a>{notification.object_name}</a>, так ка не
          были активны в течении 20 минут.
        </Notification>
      );
    }

    if (notification.type == notificationType.cardTakeOff) {
      return (
        <Notification
          title="Задача перехвачена"
          color="red"
          onClose={handleClose}
          key={notification.id}
        >
          Карточка по <a>{notification.object_name}</a> была перехвачена другим
          пользователем.
        </Notification>
      );
    }

    if (notification.type == notificationType.teaserError) {
      return (
        <Notification
          title="Ошибка в анонсе"
          color="red"
          onClose={handleClose}
          key={notification.id}
        >
          В анонсе{" "}
          <Link to={teaserListDetail(notification.object_id)} target="_blank">
            {notification.object_id}
          </Link>{" "}
          найдена ошибка. Необходимо внести правки.
        </Notification>
      );
    }

    if (notification.type == notificationType.teaserPenalty) {
      return (
        <Notification
          title="Штраф за анонс"
          color="red"
          onClose={handleClose}
          key={notification.id}
        >
          В анонсе{" "}
          <Link to={teaserListDetail(notification.object_id)} target="_blank">
            {notification.object_id}
          </Link>{" "}
          была обнаружена серьезная ошибка. Будьте внимательны.
        </Notification>
      );
    } else {
      return null;
    }
  }

  return (
    <div className="notification-list">
      <div className="notification-list__content">
        {notifications.map(notification => renderNotification(notification))}
        {notifications.length > 0 && (
          <NotificationCloseButton onClick={onAllClose}>
            Закрыть
          </NotificationCloseButton>
        )}
      </div>
    </div>
  );
};

NotificationList.defaultProps = {
  notifications: []
};

export default NotificationList;
